import React, { useContext, useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Parent from "../Parent";
import Passengers from "../Passengers/Passengers";
import PassengersHome from "../Passengers/PassengersHome/PassengersHome";
import PaymentHistoryHome from "../PaymentHistory/PaymentHistoryHome/PaymentHistoryHome";
import PaymentHistory from "../PaymentHistory/PaymentHistory";
import ParentAccount from "../ParentAccount/ParentAccount";
import PaymentComplete from "../PaymentComplete/PaymentComplete";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import { VerifyAPIs } from "../../../../API/VerifyAPIs/VerifyAPIs";
import ApiResponseHandler from "../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import { PassengerAPI } from "../../../../API/PassengerAPIs/PassengerAPIs";


export default function ParentRoutes({verified}){

    const routeParams = useParams();
    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();

    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const handleResendDetails =  async () => {
        console.log('sending');

        setSending(true);
        try{
        const account  = (await PassengerAPI.GetPortalAccount(routeParams.userID)).data;
        console.log('here');

        const response = await VerifyAPIs.PostNewVerificationLink(account);
        console.log(response);
        if(response.data === true){
            setSent(true);
        }
        }
        catch (err){
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate)
        }
        finally{
            setSending(false);
        }
    }

    const notVerified = () => {
        return(
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2rem'}}>
            <STC.Alert variant={sent ? 'success': 'warning'}>
                {sent ? 
                <>A new email has been sent to your inbox!</>
                :
                <>
                    <div style={{textAlign:'center'}}>Your email has not been verified yet. To access your account please check your inbox for a verification link.</div> 
                    <div className="m-2" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}><STC.Button disabled={sending} size='sm' onClick={handleResendDetails}>{sending ? 'Resending' : 'Resend'} Verification Link</STC.Button></div>
                </> 
                }
            </STC.Alert>
            </div>
        )
    }
    return(
        <Routes>
            <Route >
                <Route index element={<Parent/>}/>
            <Route exact path={'passengers/*'} element={verified ? <Passengers/> : notVerified()}>
                <Route index element={<PassengersHome/>}/>
                <Route exact path={":passengerID/payment-complete/*"} element={<PaymentComplete/>} />
            </Route>
            
            <Route exact path={'my-account/*'} element={<ParentAccount/>}/> 
            <Route exact path={'payment-history/*'} element={verified ? <PaymentHistory/> : notVerified()}>
                <Route index element={<PaymentHistoryHome/>}/>
            </Route> 
                
            </Route>
        </Routes>
    )

}